import * as types from '../constants';
import initialState from '../initialState';

export default function reducer(state = initialState.user, action) {
  const { type, payload } = action;
  switch (type) {
    case types.GET_USERS_SUCCESS:
      return {
        ...state,
        ...payload,
      };
    case types.SET_USER_DETAILS_SUCCESS:
      return {
        ...state,
        details: payload.details,
      };
    case types.GET_USER_ROLES_SUCCESS:
      return {
        ...state,
        roles: payload.roles,
      };
    case types.GET_USER_CUSTOMER_GROUPS_SUCCESS:
      return {
        ...state,
        customerGroups: payload.customerGroups,
      };
    case types.DELETE_USER_SUCCESS:
      return {
        ...state,
        users: state.users.filter(({ id }) => id !== payload.id),
        totalCount: state.totalCount - 1,
      };
    default:
      return state;
  }
}
